import React from 'react'
import UpsaleGroupOption from './upsale-group-option'
import createReactClass from 'create-react-class'


var UpsaleGroupOptions = createReactClass({

	render: function () {

		var upsaleOptions = this.props.upsaleOptions;

		var upsaleOptionComponentList = [];
	      for (var option in upsaleOptions) {
	        if (upsaleOptions.hasOwnProperty(option)) {
	          if ((upsaleOptions[option].visible || option === "upgradeProduct_" + this.props.productWidth) && upsaleOptions[option].type !== "paperType") {
	            upsaleOptionComponentList.push(<UpsaleGroupOption inputType="checkbox" option={upsaleOptions[option]} optionName={option} quantity={this.props.quantity} itemList={this.props.itemList} key={this.props.productId + '_' + option} name={this.props.productId + '_' + option} productId={this.props.productId} />);
	          }
	        }
	      }

	    if (upsaleOptionComponentList.length == 0) {
	    	return <div></div>;
	    }

		return (
			<div>
				<span className="ope-upsale__group__optionList-header">{_('Other')}:</span>
				<ul className="ope-upsale__group__optionList">
		            {upsaleOptionComponentList}
		        </ul>
	        </div>
		);
	}
});

export default UpsaleGroupOptions;
